import DataTable from 'datatables.net-responsive-bs5';
import MicroModal from 'micromodal';
import $ from "jquery";

class Table {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.table = self.elem.querySelector('[data-table]');
        self.toggleColumn = $(self.table).find('[data-column-toggle]');
        self.toggleColumnIndex = self.toggleColumn.index();
        
        // Index of the column to group
        self.groupColumn = self.elem.getAttribute('data-group-column');
        self.groupable = self.elem.getAttribute('data-groupable') ?? false;
        self.showGroupable = self.elem.getAttribute('data-show-group-column') ?? false;
    }

    init() {
        let self = this;

        let dataTable = new DataTable(self.table, {
            paging: false,
            info: false,
            searching: false,
            order: [[self.groupColumn, 'asc']],
            columnDefs: [
                { targets: 'no-sort', orderable: false },
                { visible: self.showGroupable, targets: self.groupColumn }
            ],
            responsive: {
                breakpoints: [
                    { name: 'xxl', width: Infinity },
                    { name: 'xl', width: 1400 },
                    { name: 'lg', width: 1200 },
                    { name: 'md', width: 992 },
                    { name: 'sm', width: 768 },
                    { name: 'xs', width: 576 }
                ],
                details: {
                    type: 'column',
                    target: self.toggleColumnIndex
                }
            },
            drawCallback: function (settings) {
                if (self.groupable && self.groupColumn) {
                    let api = this.api();
                    let rows = api.rows({ page: 'current' }).nodes();
                    let last = null;
        
                    api.column(self.groupColumn, { page: 'current' })
                        .data()
                        .each(function (group, i) {
                            if (last !== group) {
                                $(rows)
                                    .eq(i)
                                    .before(`<tr class="group"><td colspan="5" class="bg-navy text-white"><h6 class="mb-0">${group}</h6></td></tr>`);
        
                                last = group;
                            }
                        });
                }
            }
        });

        // Listen for when the responsive dropdown is opened and re-apply MicroModal to the DOM
        dataTable.on('responsive-display', function (e, datatable, row, showHide, update) {
            if (showHide) {
                MicroModal.init();
            }
        });
    }
}

export default Table;